import { ActionContext } from "vuex";
import api, { UpdatepassUpdateContractRequest } from "./api";
import log from "loglevel";

interface State {}

type MyActionContext = ActionContext<State, State>;

export default {
  namespaced: true,
  state: {} as State,
  getters: {},
  actions: {
    async updatepassUpdateContract(
      context: MyActionContext,
      params: UpdatepassUpdateContractRequest
    ) {
      try {
        const res = await api.updatepassUpdateContract(params);
        return res.data;
      } catch (error) {
        log.error("UpdatepassUpdateContract error:", error);
        throw error;
      }
    }
  },
  mutations: {}
};
